import { createSelector } from "reselect";
import { getPrescriptionGlasses, frameSkuProp, lensTypeSkuProp, packageSkuProp, addOnSkuProp } from "../../../state/selectors.internal.js";
const getProducts = createSelector(getPrescriptionGlasses, (pg) => pg.products);
const getFrames = createSelector(getProducts, (p) => p.frames);
const getLensTypes = createSelector(getProducts, (p) => p.lensTypes);
createSelector(
  getLensTypes,
  (lensTypes) => new Set(Object.keys(lensTypes))
);
const getPackages = createSelector(getProducts, (p) => p.packages);
createSelector(
  getPackages,
  (packages) => new Set(Object.keys(packages))
);
const getFrame = createSelector(
  getFrames,
  frameSkuProp,
  (frames, frameSku) => frames[frameSku]
);
const getLensType = createSelector(
  getLensTypes,
  lensTypeSkuProp,
  (lensTypes, lensTypeSku) => lensTypes[lensTypeSku]
);
const getPackage = createSelector(
  getPackages,
  packageSkuProp,
  (packages, packageSku) => packages[packageSku]
);
const getAddOns = createSelector(getProducts, (p) => p.addOns);
createSelector(getAddOns, (addOns) => new Set(Object.keys(addOns)));
const getAddOn = createSelector(
  getAddOns,
  addOnSkuProp,
  (addOns, addOnSku) => addOns[addOnSku]
);
const getBundleProductVariants = createSelector(getProducts, (p) => p.variants);
const lookupParentLensType = createSelector(
  getBundleProductVariants,
  getLensTypes,
  lensTypeSkuProp,
  (variants, lensTypes, lensTypeSku) => {
    const masterSku = variants[lensTypeSku];
    if (!masterSku) {
      return void 0;
    }
    return lensTypes[masterSku];
  }
);
const lookupParentAddOn = createSelector(
  getBundleProductVariants,
  getAddOns,
  addOnSkuProp,
  (variants, addOns, addOnSku) => {
    const masterSku = variants[addOnSku];
    if (!masterSku) {
      return void 0;
    }
    return addOns[masterSku];
  }
);
export {
  getAddOn,
  getAddOns,
  getBundleProductVariants,
  getFrame,
  getFrames,
  getLensType,
  getLensTypes,
  getPackage,
  getPackages,
  getProducts,
  lookupParentAddOn,
  lookupParentLensType
};
//# sourceMappingURL=selectors.internal.js.map
